// tokenUtils.js
// Compact token = b64url( payload_b64 + "." + sig_b64 ), where payload_b64 = b64url(JSON)
// NOTE: This CANNOT verify signature client-side (no secret). It only checks structure/exp/nbf/aud.

function b64urlToStr(s) {
  const pad = s.length % 4 === 0 ? "" : "=".repeat(4 - (s.length % 4));
  const base64 = (s + pad).replace(/-/g, "+").replace(/_/g, "/");
  try {
    return decodeURIComponent(
      atob(base64)
        .split("")
        .map(c => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
  } catch {
    return "";
  }
}

export function parseCompactToken(token) {
  // outer decode
  const inner = b64urlToStr(token);
  if (!inner || inner.indexOf(".") === -1) return { ok: false, reason: "outer_b64_invalid" };

  const [payloadB64, sigB64] = inner.split(".", 2);
  if (!payloadB64 || !sigB64) return { ok: false, reason: "segments_missing" };

  const payloadJson = b64urlToStr(payloadB64);
  if (!payloadJson) return { ok: false, reason: "payload_b64_invalid" };

  let claims;
  try {
    claims = JSON.parse(payloadJson);
  } catch {
    return { ok: false, reason: "payload_not_json" };
  }
  return { ok: true, claims, payloadB64, sigB64 };
}

export function softValidateToken(token, { audience = null, leeway = 60 } = {}) {
  const parsed = parseCompactToken(token);
  if (!parsed.ok) return parsed;

  const { claims } = parsed;
  const now = Math.floor(Date.now() / 1000);

  if (typeof claims.nbf === "number" && now + leeway < claims.nbf) {
    return { ok: false, reason: "nbf_in_future", claims };
  }
  if (typeof claims.exp === "number" && now - leeway > claims.exp) {
    return { ok: false, reason: "expired", claims };
  }
  if (audience && claims.aud && claims.aud !== audience && audience !== "*") {
    return { ok: false, reason: "aud_mismatch", claims };
  }
  // Signature cannot be verified in browser; leave that to server.
  return { ok: true, claims };
}

/**
 * Optional: round-trip to server to confirm signature.
 * Pass an endpoint that runs ogp_require_token() and returns 200 when valid.
 */
export async function serverValidateToken(token, validateUrl) {
  try {
    const r = await fetch(validateUrl, {
      method: "HEAD",
      headers: { Authorization: `Bearer ${token}` },
    });
    return r.ok
      ? { ok: true }
      : { ok: false, reason: `server_${r.status}` };
  } catch (e) {
    return { ok: false, reason: "server_error" };
  }
}
